export const SETTINGS = {
  CONFIG_NAME: 'mmWordCount',
  NAME: 'MM_WordCount',
};
